var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinimize01 = function SvgMinimize01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.712 21.5v-4.212H2.5v-1.5h5.711V21.5zm9.086 0v-5.711h5.711v1.5h-4.211V21.5zM2.5 8.212v-1.5h4.212V2.5h1.5v5.711zm13.298 0V2.5h1.5v4.212h4.212v1.5z"
  })));
};
export default SvgMinimize01;